module.exports = __webpack_public_path__ + "img/check-circle.37da10c9.svg";